'use strict'

export const CREATE_SAVE_STATE = 'create'
export const SAVED_SAVE_STATE = 'saved'

export default class BroadcastFormCtrl {

    constructor (
        $state,
        $stateParams,
        $http,
        $mdDialog,
        Broadcast,
        BroadcastRepetition,
        $scope,
        $rootScope,
        $mdToast,
        $location,
        timeFormatter,
        widgets,
        bladesManager,
        $timeout,
    ) {
        this.$state = $state
        this.$stateParams = $stateParams
        this.$scope = $scope
        this.$rootScope = $rootScope
        this._Broadcast = Broadcast
        this._BroadcastRepetition = BroadcastRepetition
        this.$http = $http
        this.buttonDisabled = false
        this.newBroadcastDate = false
        this.$mdDialog = $mdDialog
        this.$mdToast = $mdToast
        this.$location = $location
        this.timeFormatter = timeFormatter
        this.widgets = widgets
        this.bladesManager = bladesManager
        this.$timeout = $timeout
        this.searchTerm = ''
        this.ptyList = []
        this.masterStations = []

        this.showCancel = false
        this.showExtraFields = true

        // autocomplete config
        this.firstFocus = true

        this.tagText = ''

        this.broadcastType = 'program'
        this.groups = []

        this.loaded = false
        this.saveState = false
        this.updateState = false
        this.customFieldsRaw = []
        this.customFields = {}
        this.genreModel = {}
        this.formdata = {
            // Array required for UI chip helper
            group_id: null,
            presenters: [],
            genre: {},
            tags: [],
            pty_code_id: undefined,
            planned_in_epg: true,
            startDay: moment().format('YYYY-MM-DD'),
        }

        this.oldFormdata = {}

        this.boot()
        this.fetch()

        //set default repetition data
        this.formdata.repetition_start = new Date()
        this.formdata.repetition_end = new Date()
        this.formdata.repetition_type = '1 week'
        this.formdata.repetition_end.setDate(this.formdata.repetition_start.getDate() + 6)

        this.treeOptions = {
            nodeChildren: 'children',
            dirSelectable: true,
            allowDeselect: false
        }

        this.maxDate = new Date()
        this.maxDate.setDate(this.maxDate.getDate() + 730)
        this.minDate = new Date()
        this.minDate.setDate(this.maxDate.getDate() - 730)

        let localeWeekdays = moment.weekdaysShort()
        let dayNumber = 0
        this.shortDays = []
        localeWeekdays.map((localeWeekday) => {
            this.shortDays.push({
                number: dayNumber,
                name: localeWeekday
            })
            dayNumber++
        })
        let addToEnd = this.shortDays.splice(0, moment.localeData().firstDayOfWeek())
        this.shortDays = this.shortDays.concat(addToEnd)

        this.numbersOfWeek = [1, 2, 3, 4, 5]
        window.test = this.formdata

        this.$http.get('/genres/tree', { cache: true }).then(result => {
            this.treedata = result.data
        })

        if (window.CONFIG.masterstation_namespaces) {
            let masterstationData = window.CONFIG.masterstation_namespaces
            let i = 0
            if (Object.keys(masterstationData).length > 0) {
                for (let key in masterstationData) {
                    if (masterstationData.hasOwnProperty(key)) {
                        this.masterStations[i] = masterstationData[key]
                        i++
                    }
                }
            } else {
                this.masterStations = false
            }
        }

        this.$scope.$on('broadcast_new_program', this.selectCreatedProgram.bind(this))
        this.$scope.$on('made_new_presenter', this.addCreatedPresenter.bind(this))

        // If start is given, we can fill in some default times
        if ($stateParams.start && $stateParams.end) {

            let start = moment.tz($stateParams.start, window.CONFIG.timezone),
                stop = moment.tz($stateParams.end, window.CONFIG.timezone)

            this.formdata.startDay = start.format('YYYY-MM-DD')
            this.formdata.stopDay = stop.format('YYYY-MM-DD')
            this.formdata.start = start.format('HH:mm:ss')
            this.formdata.stop = stop.format('HH:mm:ss')

            this.formdata.repetition_start = new Date(this.formdata.startDay)
            let stopdate = new Date(this.formdata.startDay)
            stopdate.setDate(this.formdata.repetition_start.getDate() + 6)
            this.formdata.repetition_end = stopdate
        } else if (this.$location.path().indexOf('update') === -1) {
            this.newBroadcastDate = true
            this.formdata.start = '00:00:00'
            this.formdata.stop = '00:00:00'
        }

        this.getModelTypes().then(() => {
            this.loaded = false

            const broadcastId = this.$stateParams.broadcastId
            if (broadcastId) {
                Broadcast.get({ id: broadcastId }, (data) => {
                    // If our genre is empty fill it with a dummy object to prevent errors
                    if (data.repetition_days === undefined) {
                        console.warn('Broadcast form will throw fatal')
                        this.clearUpdateStates()
                        this.goBackRedirect()
                        return
                    }

                    if (data.genre === null) {
                        data.genre = { id: 0 }
                    } else {
                        this.loadGenre(data.genre_id)
                    }

                    if (data.station_id) {
                        delete data.title
                        delete data.medium_name
                        delete data.program
                        delete data.presenters
                        delete data.description

                    }

                    angular.extend(this.formdata, data)

                    this.formdata.repetition_days = JSON.parse(data.repetition_days)
                    this.formdata.model_type_id = data.model_type_id
                    this.formdata.group_id = data.group_id
                    this.fixBroadcastRepetitionDates()

                    //set old formdata so we can check if they are changed before update
                    this.oldFormdata = angular.copy(this.formdata)
                    this.oldFormdata.repetition_start = new Date(this.oldFormdata.repetition_start)
                    this.oldFormdata.repetition_end = new Date(this.oldFormdata.repetition_end)
                    this.oldFormdata.starttime = this.formdata.start
                    this.oldFormdata.stoptime = this.formdata.stop

                    if (data.station_id) {
                        this.broadcastType = 'station'
                    }

                    //set program title in program field
                    this.setProgramAutocompleteData(this.formdata.program)

                    this.setUrlDate(this.formdata.startDay)
                })
            } else {
                this.getBroadcastData()
            }

            //if this is a new broadcast, set published to true
            if (!this.isUpdate()) {
                this.getPublishedDefaultState()
            }
        })
    }

    boot () {
    }

    goToBroadcast (broadcastId) {
        this.$state.go('broadcast.update', { broadcastId })
    }

    savedRedirect (type, data) {
        this.$rootScope.$broadcast('broadcasts_refetch')

        if (type === CREATE_SAVE_STATE) {
            if (data.id && !data.repetition_uid) {
                this.goToBroadcast(data.id)
            } else {
                this.$state.go('broadcast', { 'reload': true })
            }
        }
    }

    goBackRedirect () {
        this.$state.go('broadcast')
    }

    addProgramRedirect (title) {
        if (this.isUpdate()) {
            this.$state.go('broadcast.update.program', { title })
        } else {
            this.$state.go('broadcast.create.program', { title })
        }
    }

    addPresenterRedirect (name) {
        if (this.isUpdate()) {
            this.$state.go('broadcast.update.presenter', { name })
        } else {
            this.$state.go('broadcast.create.presenter', { name })
        }
    }

    clearUpdateStates () {
        this.saveState = this.updateState = false
    }

    updateStartDay () {
        this.formdata.startDay = moment(this.formdata.startDay).format('YYYY-MM-DD')
    }

    fetch () {
        //this.fetchGroups()
        this.fetchPrograms().then(() => {
            this.fetchPTY()
        })
    }

    fetchPrograms () {
        return this.$http.get('/programs/all')
            .then(result => {
                return this.programs = result.data
            })
    }

    fetchGroups () {
        this.$http.get('/groups/all')
            .then(response => {
                this.groups = response.data
            })
    }

    initProgramSelect (broadcastForm) {
        const { $scope, programs, formdata } = this
        if (formdata.program_id == null) return

        const currentProgram = programs.find(program => (
            `${program.id}` === `${formdata.program_id}`
        ))

        $scope.$applyAsync(() => {
            broadcastForm.selectedProgram.$setViewValue(currentProgram)
            $scope.selectedProgram = currentProgram
        })
    }

    fetchPTY () {
        if (this.ptyList.length <= 0) {
            this.$http.get('/ptycodes/').then((response) => {
                this.ptyList = response.data.details
                this.formdata.pty_type = response.data.type
                this.applyPTYCode()
            })
        } else {
            this.applyPTYCode()
        }
    }

    applyPTYCode () {
        if (typeof this.formdata.program_id !== 'undefined') {
            this.$http.get('/programs/all').then((response) => {
                let find = this.ptyList.find((code) => {
                    let isBroadcast = response.data.find((program) => {
                        return program.id === this.formdata.program_id
                    })
                    if (typeof isBroadcast === 'undefined') return false
                    return code.id === isBroadcast.pty_code_id
                })
                if (typeof (find) !== 'undefined' && typeof (this.formdata.pty_code_id) !== 'number') {
                    this.formdata.pty_code_id = Number(find.id)
                }
            })
        }
    }

    getModelTypes () {
        return this.$http.get('/modeltypes/broadcast', { cache: true }).then((response) => {
            this.customFieldsRaw = response.data.broadcast
            response.data.broadcast.forEach((data) => {
                this.customFields[data.id] = data.fields
            })
            return response.data
        })
    }

    getPublishedDefaultState () {
        return this.$http.get('/stationsettings/settings/broadcast_default_published', { cache: true }).then((result) => {
            this.formdata.published = result.data ? result.data === 'yes' : true
        })
    }

    getBroadcastData () {
        // If the startDay has not been set yet, populate it with the start of the current EPG week
        if (!this.formdata.startDay) {
            let date = this.$location.search()['date']
            this.formdata.startDay = new Date(date)
        }
        // Copy data so we can change date to non Zulu date
        let broadcastData = angular.copy(this.formdata)
        broadcastData.genre_id = this.genreModel.id

        delete broadcastData.genreQuery

        delete broadcastData.genre
        // Format dates for Laravel
        let startDay = moment.tz(this.formdata.startDay, window.CONFIG.timezone)
        this.formdata.startDay = startDay.format('YYYY-MM-DD')
        if (this.newBroadcastDate) {
            if (!this.formdata.stopDay) {
                this.formdata.stopDay = this.formdata.startDay
            }
        }

        broadcastData.start = this.formdata.startDay + ' ' + this.formdata.start
        if (this.formdata.stop === '00:00:00') startDay.add(1, 'day')
        broadcastData.stop = startDay.format('YYYY-MM-DD') + ' ' + this.formdata.stop

        if (!broadcastData.field_values) {
            broadcastData.field_values = {}
        }

        this.loaded = true
        return broadcastData
    }

    matchModelId (matchModelType, modelTypes) {
        if (!matchModelType) {
            return
        }

        const foundModelType = modelTypes.find(modelType => modelType.name === matchModelType.name)
        return foundModelType != null ? foundModelType.id : this.customFieldsRaw[0].id
    }

    loadGenre (id) {
        this.$http.get('genres/' + id, { cache: true }).then((result) => {
            this.genreModel = result.data
        })
    }

    updateGenre (id, genres) {
        genres.forEach((genre) => {
            if (genre.id === id) {
                this.genreModel = genre
                return
            }

            if (genre.children) {
                this.updateGenre(id, genre.children)
            }
        })
    }

    genre (event) {
        this.$mdDialog.show({
            controller: 'TreeControllerDialogCtrl',
            templateUrl: 'genreDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                genreModel: this.genreModel,
            },
        })
            .then($node => {
                this.genreModel = $node
            })
    };

    fixBroadcastRepetitionDates () {
        const { formdata } = this

        this.loaded = false
        if (formdata.start) {
            let start = moment.tz(formdata.start, window.CONFIG.timezone)
            formdata.startDay = start.format('YYYY-MM-DD')
            formdata.start = start.format('HH:mm:ss')
        }

        if (formdata.stop) {
            let stop = moment.tz(formdata.stop, window.CONFIG.timezone)
            formdata.stopDay = stop.format('YYYY-MM-DD')
            formdata.stop = stop.format('HH:mm:ss')
        }

        if (formdata.repetition_start) {
            formdata.repetition_start = new Date(formdata.repetition_start)
        } else {
            formdata.repetition_start = new Date(formdata.startDay)
        }

        if (formdata.repetition_end) {
            formdata.repetition_end = new Date(formdata.repetition_end)
        } else {
            formdata.repetition_end = new Date(formdata.startDay)
            formdata.repetition_end.setDate(formdata.repetition_end.getDate() + 6)
        }

        if (formdata.repetition_days) {
            if (formdata.repetition_type !== 'month') {
                Object.getOwnPropertyNames(formdata.repetition_days).forEach(key => {
                    if ('monday tuesday wednesday thursday friday saturday sunday'.indexOf(key) > -1) {
                        formdata.repetition_days[key] = !!formdata.repetition_days[key]
                    }
                })
            }
        }

        this.loaded = true
    }

    toggleDayOfMonth (weekNumber, dayNumber) {
        if (!this.formdata.repetition_days || this.formdata.repetition_days instanceof Array || !(this.formdata.repetition_days[weekNumber] instanceof Object)) {
            this.formdata.repetition_days = {
                1: {}, 2: {}, 3: {}, 4: {}, 5: {}
            }
        }
        this.formdata.repetition_days[weekNumber][dayNumber] = !this.formdata.repetition_days[weekNumber][dayNumber]
    }

    dayOfMonthIsChecked (weekNumber, dayNumber) {
        if (this.formdata.repetition_days && this.formdata.repetition_days[weekNumber]) {
            return !!this.formdata.repetition_days[weekNumber][dayNumber]
        } else {
            return false
        }
    }

    selectedProgramChange (item) {
        const { $http, formdata, $scope, customFieldsRaw } = this

        if (!item || typeof item.id === 'undefined' || item.id === formdata.program_id) {
            return
        }

        $scope.$applyAsync(() => {
            this.showExtraFields = false
        })

        $http.get('/programs/' + item.id).then(result => {

            item = result.data

            formdata.program_id = item.id
            formdata.title = item.title
            formdata.presenters = item.presenters
            formdata.field_values = item.field_values
            formdata.description = item.description || ''
            formdata.tags = item.tags
            formdata.language = item.language
            formdata.short_name = item.short_name
            formdata.medium_name = item.medium_name
            formdata.email = item.email
            formdata.website = item.website
            formdata.group_id = item.group_id
            this.showExtraFields = true

            if (item.genre_id) {
                this.loadGenre(item.genre_id)
            }

            let modelId = this.matchModelId(item.model_type, customFieldsRaw)
            if (modelId) {
                formdata.model_type_id = modelId
            }

            for (let index in formdata.model_types) {
                if (formdata.model_types.hasOwnProperty(index)) {
                    let value = formdata.model_types[index]
                    if (value === item.model_type.name) {
                        formdata.model_type_id = index
                    }
                }
            }

            this.fetchPTY()
        })

    }

    selectCreatedProgram (e, program) {
        //add new program to all the programs
        this.programs.push(program)

        this.selectedProgramChange(program)
        this.setProgramAutocompleteData(program)
    }

    presenterSearch (query) {
        return this.$http.get('/presenters/search/' + encodeURIComponent(query))
            .then(result => result.data)
    }

    tagSearch (query) {
        return this.$http.get('/tags/search/' + encodeURIComponent(query))
            .then(result => result.data)
    }

    goPrev () {
        const { prev_broadcast_id } = this.formdata
        if (prev_broadcast_id) {
            this.loaded = false
            this.goToBroadcast(prev_broadcast_id)
        }
    }

    goNext () {
        const { next_broadcast_id } = this.formdata
        if (next_broadcast_id) {
            this.loaded = false
            this.goToBroadcast(next_broadcast_id)
        }
    }

    convertToTime () {
        this.formdata.start = this.timeFormatter.stringToTimeFormat(this.formdata.start)
        this.formdata.stop = this.timeFormatter.stringToTimeFormat(this.formdata.stop)
    }

    cancel () {
        if (!this.isUpdate()) {
            this.$rootScope.$broadcast('remove_broadcast_planning')
        }

        this.clearUpdateStates()
        this.goBackRedirect()
    }

    isUpdate () {
        return !!this.formdata.id
    }

    fixCardsSlide () {
        return new Promise(resolve => {
            let statePieces = this.$state.current.name.split('.')
            let lastState = statePieces[statePieces.length - 1]
            if (['create', 'update'].indexOf(lastState) === -1) {
                this.$state.go('^').then(() => {
                    Promise.all([
                        this.bladesManager.removeRight('program-detail', 1),
                        this.bladesManager.removeRight('presenter-detail', 1),
                    ]).then(() => {
                        resolve()
                    })
                })
            } else {
                resolve()
            }
        })
    }

    addProgram (title) {
        this.fixCardsSlide().then(() => {
            this.addProgramRedirect(title)
        })
    }

    addPresenter (name) {
        this.fixCardsSlide().then(() => {
            this.addPresenterRedirect(name)

            if (name) {
                this.searchTextPresenter = ''
            }
        })
    }

    addCreatedPresenter (e, presenter) {
        this.formdata.presenters.push(presenter)
    }

    isRepetition () {
        if (this.formdata.repetition_uid) {
            return true
        }
        if (!this.formdata.repetition_start || !this.formdata.repetition_end) {
            return false
        }

        if (this.formdata.repetition_days) {
            return angular.forEach(this.formdata.repetition_days, (day) => {
                if (day === true) {
                    return true
                }
            })
        } else {
            return false
        }
    }

    showRevisions (ev) {
        //make sure this is an update
        if (!this.isUpdate()) {
            return
        }

        this.$http.get('/revisions/broadcasts/' + this.formdata.id).then(revisions => {

            this.$mdDialog.show({

                controller: 'RevisionDialogCtrl',
                templateUrl: 'revisionDialog.ngTemplate',
                parent: angular.element(document.querySelector('#popupContainer')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    revisions: revisions.data
                }
            }).then((values) => {

                const fieldsToCopy = ['title', 'description','field_values', 'model_type_id', 'language', 'short_name', 'medium_name', 'email', 'website', 'tags']
                fieldsToCopy.forEach(field => {
                    this.formdata[field] = values[field]
                })

                const timeFieldsToCopy = ['start', 'stop']
                timeFieldsToCopy.forEach(field => {
                    this.formdata[field] = moment(values[field]).format('HH:mm:ss')
                })

                this.updateGenre(values.genre_id, this.treedata)

                this.formdata.field_values = JSON.parse(values.field_values)

                if (values.presenters) {
                    const presenters = []
                    this.formdata.presenters = presenters
                    for (let i = 0; i < values.presenters.length; i++) {
                        this.$http.get('/presenters/' + values.presenters[i]).then(result => {
                            presenters[i] = result.data
                        })
                    }
                }

                this.formdata.program_id = values.program_id
                this.$http.get('programs/' + values.program_id).then((res) => {
                    this.activeProgram = res.data
                    this.formdata.program = res.data
                })
            }).catch(() => {})

        })
    }

    save () {
        if (this.isRepetition()) {

            if (this.isUpdate()) {
                //check if the broadcast exist and becomes a new repetition
                if (!this.formdata.repetition_uid || this.areRepetitionDatesDirty()) {
                    this.showRepetitionUpdateDialog('update')
                } else {
                    this.showRepetitionRangeDialog()
                }
            } else {
                this.createRepetition()
            }
        } else {
            this.saveBroadcast()
        }
    }

    saveBroadcast () {
        this.buttonDisabled = true
        this.widgets.saveWidgetsForTypeId('broadcast-' + this.formdata.id).then(() => {
            let broadcastData = this.getBroadcastData()

            broadcastData.pty_code_id = Number(broadcastData.pty_code_id)

            delete broadcastData.repetition_start
            delete broadcastData.repetition_end
            delete broadcastData.repetition_type
            delete broadcastData.repetition_days

            this._Broadcast.save(broadcastData, data => {
                if (!this.isUpdate()) {
                    this.$rootScope.$broadcast('wait_for_broadcast_update', { broadcastId: data.id })
                }

                let type = broadcastData.id ? SAVED_SAVE_STATE : CREATE_SAVE_STATE
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.' + type + '?object=Broadcast&title=' + broadcastData.title,
                    hideDelay: 3000,
                    position: ('top right')
                })

                this.clearUpdateStates()
                this.savedRedirect(type, data)
                this.buttonDisabled = false
            }, data => {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.error_message?plain_error=' + data.data.error,
                    hideDelay: 3000,
                    position: ('top right')
                });
                this.buttonDisabled = false
            })
        })
    }

    createRepetitionSave (broadcastRepetitionData) {
        broadcastRepetitionData.id = this.formdata.repetition_uid
        broadcastRepetitionData.starttime = this.formdata.start
        broadcastRepetitionData.stoptime = this.formdata.stop

        this._BroadcastRepetition.save(broadcastRepetitionData, data => {
            this.clearUpdateStates()
            this.savedRedirect(CREATE_SAVE_STATE, data)
            this.buttonDisabled = false

            if (!this.isUpdate()) {
                this.$rootScope.$broadcast('wait_for_broadcast_update', { repetitionId: data.repetition_uid })
            }

            let type = broadcastRepetitionData.id ? SAVED_SAVE_STATE : CREATE_SAVE_STATE
            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.' + type + '?object=Broadcast&title=' + broadcastRepetitionData.title,
                hideDelay: 3000,
                position: ('top right')
            })
            this.clearUpdateStates()
            this.savedRedirect(type, data)
            this.buttonDisabled = false
        }, data => {
            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.error_message?plain_error=' + data.data.error,
                hideDelay: 3000,
                position: ('top right')
            });
            this.buttonDisabled = false
        })
    }

    createRepetition () {
        this.buttonDisabled = true

        this.widgets.saveWidgetsForTypeId('broadcast-' + this.formdata.id).then(() => {
            let broadcastRepetitionData = this.getBroadcastData()

            if (!this.isUpdate()) {
                let broadcastData = _.clone(broadcastRepetitionData)

                broadcastData.pty_code_id = Number(broadcastData.pty_code_id)
                delete broadcastData.repetition_start
                delete broadcastData.repetition_end
                delete broadcastData.repetition_type
                delete broadcastData.repetition_days

                this._Broadcast.save(broadcastData, data => {
                    broadcastRepetitionData.broadcast_template_id = data.id
                    this.createRepetitionSave(broadcastRepetitionData)
                }, data => {
                    this.$mdToast.show({
                        templateUrl: '/partial/app.partials.toasts.error_message?plain_error=' + data.data.error,
                        hideDelay: 3000,
                        position: ('top right')
                    });
                    this.buttonDisabled = false
                })
            } else {
                broadcastRepetitionData.broadcast_template_id = broadcastRepetitionData.id
                this.createRepetitionSave(broadcastRepetitionData)
            }
        })
    }

    checkRepetitionDate (curr, old) {
        let currRepDate = new Date(curr),
            oldRepDate = new Date(old)
        currRepDate.setHours(0, 0, 0, 0)
        oldRepDate.setHours(0, 0, 0, 0)
        return +currRepDate !== +oldRepDate ? curr : null
    }

    areRepetitionDatesDirty () {
        if (!angular.equals(this.formdata.repetition_days, this.oldFormdata.repetition_days) || !angular.equals(this.formdata.repetition_type, this.oldFormdata.repetition_type)) {
            console.log('days and/or type are not equal')
            return true
        }
        if (this.checkRepetitionDate(this.formdata.repetition_start, this.oldFormdata.repetition_start) != null) {
            console.log('start not equal')
            return true
        }
        if (this.checkRepetitionDate(this.formdata.repetition_end, this.oldFormdata.repetition_end) != null) {
            console.log('end not equal')
            return true
        }
        return false
    }

    updateRepetition (fromBroadcastToRep = false) {
        this.buttonDisabled = true

        this.widgets.saveWidgetsForTypeId('broadcast-' + this.formdata.id).then(() => {
            let broadcastData = this.getBroadcastData()

            broadcastData.id = this.formdata.repetition_uid
            broadcastData.starttime = this.formdata.start
            broadcastData.stoptime = this.formdata.stop

            let filteredValues = {}
            if (!fromBroadcastToRep && this.formdata.repetition_uid) {
                //check which values are dirty, so we only save changed values
                angular.forEach(broadcastData, (value, key) => {
                    if (!angular.equals(broadcastData[key], this.oldFormdata[key])) {
                        filteredValues[key] = value
                    }
                })
                //check if the dates for the repetition is changed or not
                filteredValues.repetition_start = this.checkRepetitionDate(this.formdata.repetition_start, this.oldFormdata.repetition_start)
                if (!filteredValues.repetition_start) {
                    delete filteredValues.repetition_start
                }
                filteredValues.repetition_end = this.checkRepetitionDate(this.formdata.repetition_end, this.oldFormdata.repetition_end)
                if (!filteredValues.repetition_end) {
                    delete filteredValues.repetition_end
                }
            } else {

                filteredValues = broadcastData
                delete filteredValues.blocks
            }

            delete filteredValues.start
            delete filteredValues.stop

            //set some data that always needs to be send
            filteredValues.broadcast_template_id = this.formdata.id
            filteredValues.id = broadcastData.repetition_uid
            filteredValues.rangeStart = this.saveRangeStart
            filteredValues.rangeStop = this.saveRangeStop || broadcastData.repetition_end

            this._BroadcastRepetition.save(filteredValues, data => {
                this.clearUpdateStates()
                this.savedRedirect(SAVED_SAVE_STATE, data)
                this.buttonDisabled = false
            }, (data) => {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.error_message?plain_error=' + data.data.error,
                    hideDelay: 3000,
                    position: ('top right')
                });
                this.buttonDisabled = false
            })
        })
    }

    destroy (ev) {

        const repetition = this.formdata.repetition_uid !== null

        this.$http.post('/deletebroadcastrepetitionwarning', this.formdata).then((result) => {
            this.repetitionchangecount = result.data
        })

        this.$http.post('/deletewarning', { model: 'broadcast', id: this.formdata.id }).then((result) => {
            this.singlechangecount = result.data

            if (!repetition) {
                this.$mdDialog.show({
                    controller: 'ConfirmManyDialogCtrl',
                    templateUrl: 'confirmManyDialog.ngTemplate',
                    parent: angular.element(document.querySelector('#popupContainer')),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        count: this.singlechangecount,
                        option: null
                    }
                }).then(() => {

                    this._Broadcast.delete({ id: this.formdata.id }, () => {
                        this.clearUpdateStates()
                        this.goBackRedirect()

                        this.$mdToast.show({
                            templateUrl: '/partial/app.partials.toasts.delete?object=Broadcast&title=' + this.formdata.title, //@trans('labels.broadcast')
                            hideDelay: 3000,
                            position: ('top right')
                        })
                    })
                }).catch(angular.noop)
                return
            }

            this.$mdDialog.show({
                controller: 'ConfirmManyDialogCtrl',
                templateUrl: 'broadcastDeleteDialog.ngTemplate',
                parent: angular.element(document.querySelector('#popupContainer')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    count: ' ',
                    option: repetition
                }
            }).then((request) => {
                if (request === 'single' || !request) {
                    this.$mdDialog.show({
                        controller: 'ConfirmManyDialogCtrl',
                        templateUrl: 'confirmManyDialog.ngTemplate',
                        parent: angular.element(document.querySelector('#popupContainer')),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            count: this.singlechangecount,
                            option: null
                        }
                    }).then(() => {

                        this._Broadcast.delete({ id: this.formdata.id }, () => {
                            this.clearUpdateStates()
                            this.goBackRedirect()

                            this.$mdToast.show({
                                templateUrl: '/partial/app.partials.toasts.delete?object=Broadcast&title=' + this.formdata.title, //@trans('labels.broadcast')
                                hideDelay: 3000,
                                position: ('top right')
                            })
                        })
                    }).catch(angular.noop)
                } else if (request === 'serie') {
                    this.$mdDialog.show({
                        controller: 'ConfirmManyDialogCtrl',
                        templateUrl: 'confirmManyDialog.ngTemplate',
                        parent: angular.element(document.querySelector('#popupContainer')),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            count: this.repetitionchangecount,
                            option: null
                        }
                    }).then(() => {
                        this.clearUpdateStates()
                        this.goBackRedirect()
                        this.$http.post('/broadcastrepetitions/deleterepetition', this.formdata).then((result) => {
                            this.$mdToast.show({
                                templateUrl: '/partial/app.partials.toasts.queued_delete?object=repetition&title=' + result.data, //@trans('labels.broadcast')
                                hideDelay: 3000,
                                position: ('top right')
                            })
                        })
                    }).catch(angular.noop)

                }
            }).catch(angular.noop)

        })

    }

    showRepetitionRangeDialog () {
        let mainCard = angular.element('.epg-card')
        mainCard.addClass('small-height')
        this.saveState = true

        this.saveType = 'broadcast'
        this.saveRangeStart = new Date(this.formdata.startDay)
        this.saveRangeStop = angular.copy(this.formdata.repetition_end)
        this.changecount = this.repetitionchangecount = ''
    }

    showRepetitionUpdateDialog (state) {
        let mainCard = angular.element('.epg-card')
        mainCard.addClass('small-height')
        this.updateState = true

        if (state === 'update') {

            this.$http.post('/changebroadcastrepetitionwarning', this.formdata).then((result) => {
                this.repetitionchangecount = result.data
            })

        } else {

            if (this.saveType === 'broadcast') {
                this.saveBroadcast()

            } else {

                let senddata = {
                    'repetition_uid': this.formdata.repetition_uid,
                    'save_range_start': moment(this.saveRangeStart).format('Y-MM-DD'),
                    'save_range_stop': moment(this.saveRangeStop).format('Y-MM-DD')
                }

                this.$http.post('/broadcastrepetitions/broadcastchangecount', senddata).then((result) => {
                    this.changecount = result.data
                })

            }
        }

    }

    cancelRepetitionDialog () {
        let mainCard = angular.element('.epg-card')
        mainCard.removeClass('small-height')
        this.saveState = this.updateState = false
    }

    saveRepetitionRangeDialog () {
        if (this.saveType === 'broadcast') {
            this.saveBroadcast()
        } else {
            this.updateRepetition()
        }
    }

    setUrlDate (startDate) {
        const current = moment(startDate).format('YYYY-MM-DD')
        if (this.$location.search()['date'] !== current) {
            this.$location.search('date', current)
        }
    }

    autoFocusSearch () {
        setTimeout(() => {
            $('input#program-search').focus()
        }, 100)
    }

    setProgramAutocompleteData (program) {
        setTimeout(() => {
            let title = !!program ? program.title : ''
            this.$scope.selectedProgram = !!program ? program : undefined
            this.$scope.searchTerm = title
        }, 0)
    }

    stopKeyDown (ev) {
        ev.stopPropagation()
    }

    clearSearchTerm () {
        this.searchTerm = ''
    }

    checkBroadcastType () {
        if (this.broadcastType === 'program') {
            this.formdata.station_id = null
        } else {
            this.formdata.planned_in_epg = true
        }
    }

}

BroadcastFormCtrl.$inject = [
    '$state',
    '$stateParams',
    '$http',
    '$mdDialog',
    'Broadcast',
    'BroadcastRepetition',
    '$scope',
    '$rootScope',
    '$mdToast',
    '$location',
    'timeFormatter',
    'widgets',
    'bladesManager',
    '$timeout',
]
